import BadgeLogAdapter from 'garaje/adapters/badge-log';

export default class AccessEventAdapter extends BadgeLogAdapter {}
